import { z } from "zod";

export const GROUP_NAME_MAX_LENGTH = 28;
export const DESCRIPTION_MAX_LENGTH = 50;

export const createUserGroupSchema = z.object({
  groupName: z
    .string()
    .max(
      GROUP_NAME_MAX_LENGTH,
      `User Group name must be ${GROUP_NAME_MAX_LENGTH} characters or less`,
    )
    .refine((val) => !/\s{2,}/.test(val), {
      message: "Group name cannot contain consecutive spaces",
    }),
  description: z
    .string()
    .max(
      DESCRIPTION_MAX_LENGTH,
      `Description must be ${DESCRIPTION_MAX_LENGTH} characters or less`,
    )
    .refine((val) => !/\s{2,}/.test(val), {
      message: "Description cannot contain consecutive spaces",
    })
    .optional(),
  isDefaultUserGroup: z.boolean().optional(),
});

export type CreateUserGroupFormData = z.infer<typeof createUserGroupSchema>;
